import { render } from "./ContentblockOpeninghours.vue?vue&type=template&id=22c8ede7&scoped=true&ts=true"
import script from "./ContentblockOpeninghours.ts?vue&type=script&lang=ts"
export * from "./ContentblockOpeninghours.ts?vue&type=script&lang=ts"

import "./ContentblockOpeninghours.scss?vue&type=style&index=0&id=22c8ede7&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c8ede7"]])

export default __exports__